const ENUM_SUPPLY_TYPE = [{ s_type: "OutWard" }, { s_type: "InWard" }]
const ENUM_NOTE_TYPE = [{ n_type: "CREDIT" }, { n_type: "DEBIT" }]
const ENUM_TRADE_TYPE = [{ t_type: "RD" }, { t_type: "URD" }, { t_type: "OGS" }]
const ENUM_INVOICE_TYPE = [
  { value: "S", label: "S" },
  { value: "P", label: "P" },
  { value: "I", label: "I" },
  { value: "J", label: "J" },
]
const ENUM_CRDRNOTE_TYPE = [
  { value: "02-Post Sale Discount" },
  { value: "03-Deficiency in service" },
  { value: "04-Correction in invoice" },
  { value: "05-Change in POS" },
  { value: "06-Finalization of Provisional assessment" },
  { value: "07-Others" },
  { value: "TCS" },
  { value: "TDS" },
]
 const ENUM_ROWS_FIELD = {
   acYear: "acYear",
   invType: "invType",
   invNo: "invNo",
   itemName: "itemName",
   printDetail: "printDetail",
   qty: "qty",
   rate: "rate",
   amount: "amount",
   discPer: "discPer",
   discAmt: "discAmt",
   stPer: "stPer",
   stAmt: "stAmt",
   astPer: "astPer",
   astAmt: "astAmt",
   netAmt: "netAmt",
 }
 const ENUM_INITIALROW = {
   acYear: 1,
   invType: "",
   invNo: "",
   itemName: "",
   printDetail: "",
   qty: 0,
   rate: 0,
   amount: 0,
   discPer: 0,
   discAmt: 0,
   stPer: 0,
   stAmt: 0,
   astPer: 0,
   astAmt: 0,
   netAmt: 0,
   detailId: 0,
 }
 function fun_calTcs_Amt(netAmount,tcsPer) {
   let res = (Number(netAmount) * Number(tcsPer)) / 100
   return res.toFixed(2)
 }
  function fun_calTotalTax(totalGstTax,totalSgstTax) {
    let res = Number(totalGstTax) + Number(totalSgstTax)
    return res.toFixed(2)
  }
  function fun_calTds_Amt(grossAmt,tdsPer) {
    let res = (Number(grossAmt) * Number(tdsPer)) / 100
    return res.toFixed(2)
  }
  function fun_calNet_Amt(amount, discAmt, stAmt, astAmt) {
    let res =
      (Number(amount) - Number(discAmt)) + (Number(stAmt) + Number(astAmt))
    return Math.round(res)
  }
export {
  ENUM_CRDRNOTE_TYPE,
  ENUM_INVOICE_TYPE,
  ENUM_NOTE_TYPE,
  ENUM_SUPPLY_TYPE,
  ENUM_TRADE_TYPE,
  ENUM_ROWS_FIELD,
  ENUM_INITIALROW,
  fun_calTotalTax,
  fun_calTds_Amt,
  fun_calNet_Amt,
  fun_calTcs_Amt,
}


// const getMsmeType = (val, field) => {
//   const selectedOption = ENUM_MSME_TYPE.filter(option => option[field] == val);
//   if (field == "key")
//       return selectedOption[0].value
//   else
//       return selectedOption[0].key
// }
// const getGPType = (val, filterKey, form_field, ret_field) => {
//   if (dataPartyTradeState && dataPartyTradeState.itemGstType) {
//       if (form_field == formField.gstType) {
//           const selectedOption = dataPartyTradeState.itemGstType.filter(ele => ele[filterKey] == val)
//           return String(selectedOption[0][ret_field])
//       }
//   }
//   if (dataPartyTradeState && dataPartyTradeState.itemParty) {
//       if (form_field == formField.partyType) {
//           const selectedOption = dataPartyTradeState.itemParty.filter(ele => ele[filterKey] == val)
//           return String(selectedOption[0][ret_field])
//       }
//   }

// }
 // if (formData.msmeType != "")
        // mSType = getMsmeType(formData.msmeType, "key")

        //let set_selGstType = getGPType(formData.gstType, "RowKey", formField.gstType, "TypeID")
        // let set_selPartyType = getGPType(formData.partyType, "RowKey", formField.partyType, "TypeID")
        //gstType: set_selGstType, partyType: set_selPartyType